var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4555_68007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1914 8.35929L19.7227 18.984C19.6878 19.0911 19.6292 19.1889 19.5514 19.2703C19.4735 19.3517 19.3783 19.4144 19.2728 19.454C19.1674 19.4935 19.0543 19.5088 18.9422 19.4987C18.83 19.4886 18.7215 19.4533 18.6249 19.3955C18.6033 19.3824 16.2061 18.0015 11.9986 18.0015C7.79111 18.0015 5.39392 19.3824 5.37048 19.3965C5.27383 19.4537 5.16557 19.4885 5.05367 19.4983C4.94178 19.508 4.82912 19.4925 4.72402 19.4529C4.61891 19.4134 4.52404 19.3507 4.4464 19.2695C4.36877 19.1883 4.31036 19.0907 4.27548 18.984L0.80861 8.35648C0.738757 8.14374 0.733374 7.91509 0.793138 7.69929C0.852902 7.4835 0.975145 7.2902 1.14449 7.1437C1.31383 6.9972 1.52272 6.90405 1.74487 6.87596C1.96702 6.84788 2.19251 6.88611 2.39298 6.98586L7.0983 9.32961L11.0283 2.79898C11.1293 2.63147 11.2719 2.49291 11.4422 2.39673C11.6126 2.30054 11.8049 2.25 12.0005 2.25C12.1961 2.25 12.3884 2.30054 12.5587 2.39673C12.7291 2.49291 12.8716 2.63147 12.9727 2.79898L16.9027 9.32961L21.6099 6.98586C21.8106 6.88596 22.0364 6.84779 22.2588 6.87614C22.4811 6.90449 22.6901 6.99811 22.8594 7.14516C23.0286 7.29221 23.1504 7.48611 23.2095 7.70237C23.2686 7.91863 23.2623 8.14755 23.1914 8.36023V8.35929Z",
    fill: "url(#paint0_linear_4555_68007)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4555_68007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4606 9.57286L17.1481 16.656C17.1249 16.7274 17.0858 16.7926 17.0339 16.8469C16.982 16.9011 16.9185 16.943 16.8482 16.9693C16.7779 16.9957 16.7026 17.0059 16.6278 16.9991C16.553 16.9924 16.4807 16.9689 16.4162 16.9304C16.4019 16.9216 14.8037 16.001 11.9987 16.001C9.19375 16.001 7.59562 16.9216 7.58 16.931C7.51556 16.9691 7.44338 16.9923 7.36879 16.9988C7.2942 17.0054 7.21909 16.995 7.14902 16.9686C7.07895 16.9422 7.0157 16.9004 6.96394 16.8463C6.91219 16.7922 6.87325 16.7272 6.85 16.656L4.53875 9.57099C4.49218 9.42916 4.48859 9.27673 4.52843 9.13286C4.56828 8.989 4.64977 8.86013 4.76267 8.76247C4.87556 8.6648 5.01482 8.6027 5.16292 8.58398C5.31102 8.56525 5.46135 8.59074 5.595 8.65724L8.73187 10.2197L11.3519 5.86599C11.4192 5.75432 11.5143 5.66194 11.6278 5.59782C11.7414 5.53369 11.8696 5.5 12 5.5C12.1304 5.5 12.2586 5.53369 12.3722 5.59782C12.4857 5.66194 12.5808 5.75432 12.6481 5.86599L15.2681 10.2197L18.4062 8.65724C18.5401 8.59064 18.6906 8.56519 18.8388 8.58409C18.9871 8.60299 19.1264 8.6654 19.2393 8.76344C19.3521 8.86148 19.4333 8.99074 19.4727 9.13491C19.5121 9.27909 19.5079 9.4317 19.4606 9.57349V9.57286Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4555_68007",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4555_68007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4555_68007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4555_68007",
    x1: 1.96277,
    y1: -2.60204,
    x2: 13.8493,
    y2: 19.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEC37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B0822E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504128,
    stopColor: "#DEC37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#B0822E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0BD7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4555_68007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerTag);
export default __webpack_public_path__ + "static/media/manager_tag.28caa1b96e2c2167e351a9753263a9b9.svg";
export { ForwardRef as ReactComponent };